import BookingFormField from './BookingFormField';
import { propertyLabelTranslator } from 'property-translator/propertyTranslator';
import { jsx as _jsx } from "react/jsx-runtime";
const CustomFormInputs = ({
  formFields,
  customFormFields,
  onCustomFormFieldChange,
  formStateValidation,
  disabled
}) => /*#__PURE__*/_jsx("div", {
  style: {
    wordWrap: 'break-word'
  },
  children: formFields.map(field => {
    var _field$type, _field$fieldType, _field$numberDisplayH;
    return /*#__PURE__*/_jsx(BookingFormField, {
      fieldValue: customFormFields.get(field.name),
      fieldName: field.name,
      validation: formStateValidation.get(field.name),
      setFormValue: onCustomFormFieldChange,
      type: (_field$type = field.type) !== null && _field$type !== void 0 ? _field$type : undefined,
      fieldType: (_field$fieldType = field.fieldType) !== null && _field$fieldType !== void 0 ? _field$fieldType : undefined,
      isRequired: field.isRequired,
      fieldLabel: propertyLabelTranslator(field.label),
      fieldOptions: field.options,
      fieldIsCustom: field.isCustom,
      numberDisplayHint: (_field$numberDisplayH = field.numberDisplayHint) !== null && _field$numberDisplayH !== void 0 ? _field$numberDisplayH : undefined,
      disabled: disabled
    }, `${field.name}`);
  })
});
export default CustomFormInputs;